import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { AppText } from '@streem/ui-react';
export const Timer = ({ callStartTime }) => {
    const [timeInSeconds, setTimeInSeconds] = useState('');
    useEffect(() => {
        if (callStartTime) {
            const callStartTimeInNanoSeconds = callStartTime?.seconds?.low || 0 + (callStartTime?.nanos || 0) / 1000000000;
            const timer = window.setInterval(async () => {
                const currentTimeInNanoSeconds = new Date().getTime() / 1000;
                setTimeInSeconds(convertTimeStampToReadableString(currentTimeInNanoSeconds - callStartTimeInNanoSeconds));
            }, 1000);
            return () => window.clearInterval(timer);
        }
        else
            return;
    }, [timeInSeconds, callStartTime]);
    return (_jsx(AppText, { bold: true, size: "medium", color: "dark", style: { marginRight: '.75rem', marginLeft: '1.5rem', minWidth: '1.75rem' }, "data-testid": "in-call-timer", children: timeInSeconds || '0:00' }));
};
const convertTimeStampToReadableString = (secondsElapsed) => {
    const minutes = Math.floor(secondsElapsed / 60);
    const seconds = Math.floor(secondsElapsed % 60);
    return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
};
//# sourceMappingURL=timer.js.map